import {
  FETCH_AGENT_SUPPORT_TICKETS_REQUEST,
  FETCH_AGENT_SUPPORT_TICKETS_SUCCESS,
  FETCH_AGENT_SUPPORT_TICKETS_FAILURE,
  UPDATE_AGENT_SUPPORT_TICKET_REQUEST,
  UPDATE_AGENT_SUPPORT_TICKET_SUCCESS,
  UPDATE_AGENT_SUPPORT_TICKET_FAILURE,
} from "./types";

import {
  fetchAgentsSupportTickets,
  updateAgentSupportTicket,
} from "../../services/agentSupportService";

// Action creators
export const fetchAgentSupportTicketsRequest = () => ({
  type: FETCH_AGENT_SUPPORT_TICKETS_REQUEST,
});

export const fetchAgentSupportTicketsSuccess = (tickets) => ({
  type: FETCH_AGENT_SUPPORT_TICKETS_SUCCESS,
  payload: tickets,
});

export const fetchAgentSupportTicketsFailure = (error) => ({
  type: FETCH_AGENT_SUPPORT_TICKETS_FAILURE,
  payload: error,
});

export const updateAgentSupportTicketRequest = () => ({
  type: UPDATE_AGENT_SUPPORT_TICKET_REQUEST,
});

export const updateAgentSupportTicketSuccess = (ticket) => ({
  type: UPDATE_AGENT_SUPPORT_TICKET_SUCCESS,
  payload: ticket,
});

export const updateAgentSupportTicketFailure = (error) => ({
  type: UPDATE_AGENT_SUPPORT_TICKET_FAILURE,
  payload: error,
});

// Fetch Agent Support Tickets
export const fetchAgentSupportTicketsAction =
  (page = 1, size = 10) =>
  async (dispatch) => {
    dispatch(fetchAgentSupportTicketsRequest());

    try {
      const response = await fetchAgentsSupportTickets(page, size);

      if (response.success) {
        dispatch(
          fetchAgentSupportTicketsSuccess(response.data)
        );
      } else {
        dispatch(
          fetchAgentSupportTicketsFailure(response.error)
        );
      }

      return response;
    } catch (error) {
      const err =
        error.message || "Failed to fetch Agent Support Tickets";

      dispatch(fetchAgentSupportTicketsFailure(err));

      return {
        success: false,
        error: err,
      };
    }
  };

// Update Agent Support Ticket
export const updateAgentSupportTicketAction =
  (ticketId, payload) =>
  async (dispatch) => {
    dispatch(updateAgentSupportTicketRequest());

    try {
      const response = await updateAgentSupportTicket(
        ticketId,
        payload
      );

      if (response.success) {
        dispatch(
          updateAgentSupportTicketSuccess(response.data)
        );
      } else {
        dispatch(
          updateAgentSupportTicketFailure(response.error)
        );
      }

      return response;
    } catch (error) {
      const err =
        error.message || "Failed to update Agent Support Ticket";

      dispatch(updateAgentSupportTicketFailure(err));

      return {
        success: false,
        error: err,
      };
    }
  };